(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.updateHeight = this.updateHeight.bind(this);
      this.updateHeight();
      this.resizeObserver = new ResizeObserver(this.updateHeight);
      this.resizeObserver.observe(this.section);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--announcement-bar-height');
    }

    updateHeight() {
      const root = document.documentElement;
      const rootFontSize = parseFloat(getComputedStyle(root).fontSize) || 16;
      const height = (this.section.getBoundingClientRect().height / rootFontSize).toFixed(4);
      root.style.setProperty('--announcement-bar-height', `${height}rem`);
    }
  }

  if (!customElements.get('sticky-announcement-bar')) {
    customElements.define('sticky-announcement-bar', StickyAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-countdown-bar"]) return;
  try {
    
  // Keeps --countdown-height (used by the search modal placement) in sync with the bar,
  // whether or not the bar is sticky. Re-run on Theme Editor section reloads.
  (() => {
    let observer;

    const syncCountdownHeight = () => {
      const bar = document.querySelector('.shopify-section-countdown-bar');
      const root = document.documentElement;
      const update = () => {
        const rootFontSize = parseFloat(getComputedStyle(root).fontSize) || 16;
        const height = bar ? (bar.getBoundingClientRect().height / rootFontSize).toFixed(4) : 0;
        root.style.setProperty('--countdown-height', `${height}rem`);
      };

      if (observer) observer.disconnect();
      update();
      if (bar && 'ResizeObserver' in window) {
        observer = new ResizeObserver(update);
        observer.observe(bar);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncCountdownHeight);
    } else {
      syncCountdownHeight();
    }
    document.addEventListener('shopify:section:load', syncCountdownHeight);
    document.addEventListener('shopify:section:unload', syncCountdownHeight);
  })();

  class StickyCountdownBar extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.updateHeight = this.updateHeight.bind(this);
      this.updateHeight();
      this.resizeObserver = new ResizeObserver(this.updateHeight);
      this.resizeObserver.observe(this.section);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.documentElement.style.setProperty('--countdown-bar-height', '0rem');
    }

    updateHeight() {
      const root = document.documentElement;
      const rootFontSize = parseFloat(getComputedStyle(root).fontSize) || 16;
      const height = (this.section.getBoundingClientRect().height / rootFontSize).toFixed(4);
      root.style.setProperty('--countdown-bar-height', `${height}rem`);
    }
  }

  if (!customElements.get('sticky-countdown-bar')) {
    customElements.define('sticky-countdown-bar', StickyCountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle button');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        const isOpen = this.header.classList.toggle('shopify-section-header-menu-open');
        this.toggleBtn.setAttribute('aria-expanded', isOpen);
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    get hasAnnouncementOffset() {
      const styles = getComputedStyle(document.documentElement);
      const bar = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      const countdown = parseFloat(styles.getPropertyValue('--countdown-bar-height')) || 0;
      return bar > 0 || countdown > 0;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.reset();
        document.body.classList.remove('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (!this.hasAnnouncementOffset && scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;

          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (!this.hasAnnouncementOffset && scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
